import React, { useEffect, useState } from "react";
import classes from "./PrepareResult.module.scss";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import { useNavigate } from "react-router-dom";
import headerImage from "../../static/images/prepare-header.png";
import { atom, useAtom } from "jotai";
import { emailAtom } from "../prepare-register/PrepareRegister";
import teacherImage from "../../static/images/teacher-mail.png";

function PrepareResult() {
  const navigate = useNavigate();
  const [email, setEmail] = useAtom(emailAtom);
  
  return (
    <div className={classes.container}>
      <div className={classes.body}>
        <img className={classes.header} src={headerImage} alt={headerImage} />
        <img src={teacherImage} alt={teacherImage} />
        <div className={classes.summary}>
          以下のメールアドレスに
          <br />
          3日以内に
          <br />
          結果を送信します。
        </div>
        <div className={classes.email}>{email}</div>
        <div className={classes.text}>
          に、「みらいいコンシェル{" "}
          <span className={classes.strong}>
            &lt;support@miraii-concierge.jp&gt;
          </span>
          」から「仮利用登録完了のお知らせメール」を送信しました。メール本文に記載されているURLから、本利用登録をお願いいたします。
          数分経っても届かない場合は、迷惑メールフォルダをご確認ください。
        </div>
        <div className={classes.caption}>
          <div
            className={`${classes.title} ${classes.text} ${classes.red} ${classes.strong} ${classes.center}`}
          >
            メールが届きませんか？
          </div>
          <div className={`${classes.text} ${classes.red}`}>
            入力いただいたメールアドレスが登録されていないか、登録いただいた際にメールアドレスが誤っていた可能性がございます。お手数ですが
            <a
              className={classes.link}
              target="_blank"
              rel="noreferrer"
              href="https://form.run/@miraii-concierge-contact"
            >
              こちらのリンク
            </a>
            からお問い合わせください。
          </div>
        </div>
        <BreadCrumb
          data={[
            { displayName: "みらいいコンシェル", url: "/top" },
            { displayName: "メール送信完了", url: "/familynavi" },
          ]}
        />
      </div>
    </div>
  );
}

export default PrepareResult;
